import { Box, Text } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

function PopupBox({
  title, value, fontSize, subtext, isVisible,
}) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <Box
      textAlign="center"
      position="fixed"
      left={mousePosition.x}
      top={mousePosition.y}
      transform="translate(-50%, -110%)"
      bg="whiteAlpha.700"
      boxShadow="md"
      borderRadius="md"
      p={2}
      zIndex={1000}
      minWidth={75}
      pointerEvents="none"
      backdropFilter="blur(4px)"
    >
      <Text fontSize={14}>{title}</Text>
      <Text
        fontSize={fontSize}
        fontWeight="bold"
      >
        {value}
      </Text>
      {subtext && (<Text fontSize={12}>{subtext}</Text>)}
    </Box>
  );
}

export default PopupBox;
